/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

import "~/global/_aviationHeader";
import "~/global/_siteSearch.js";
import "~/global/aviation/_siteSearch.js";
import "~/global/aviation/_footer.js";

import "~/components/multisite/_blueform";
import "~/components/aviationcareers/_aviationNews";
import "~/components/aviationcareers/_aviationFeatureSlider";
import "~/components/aviationcareers/_aviationHero.js";
import "~/components/aviationcareers/_careerSearchResults";
import "~/components/aviationcareers/_careerComparison";
import "~/components/aviationcareers/_careerPlanningTool";
import "~/components/aviationcareers/_programSearchResults";
import "~/components/aviationcareers/_aviationBlog";
import "~/components/_descriptiveCarousel";
import "~/components/_masonryGrid";
import "~/components/_interiorVideoRail";
import "~/components/_accordion";
import "~/components/_galleryLightbox";